import type { StepConfigItem } from './types';

export const customV61: StepConfigItem[] = [
  {
    name: 'customV2_startPageV38',
    hideHeader: true,
    progressTitle: 'customV2_progress_text11',
  },
  {
    name: 'start_page_age',
    hideProgress: true,
  },
  {
    name: 'customV2_policyPageV2',
    hideHeader: true,
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_health',
  },
  {
    name: 'customV2_info_breed',
    separationStep: true,
    hideHeader: true,
    progressTitle: 'customV2_progress_text2',
  },
  {
    name: 'customV2_potty',
  },
  {
    name: 'customV2_issues',
  },
  {
    name: 'statement_irritation',
  },
  {
    name: 'crate_trained',
  },
  {
    name: 'info_about_crate',
    hideHeader: true,
  },
  {
    name: 'customV2_walking_issues',
  },
  {
    name: 'customV2_activity',
  },
  {
    name: 'customV2_info_breed_2',
    separationStep: true,
    hideHeader: true,
    progressTitle: 'customV2_progress_text3',
  },
  {
    name: 'customV2_command_1',
  },
  {
    name: 'statement_ignore_commands',
  },
  {
    name: 'customV2_reason',
  },
  {
    name: 'customV2_date',
  },
  {
    name: 'customV2_info_predict',
    hideHeader: true,
  },
  {
    name: 'customV2_training_time',
  },
  {
    name: 'customV2_training',
  },
  {
    name: 'age_group',
  },
  {
    name: 'statement_strong_bond',
  },
  {
    name: 'customV2_creating_program',
    hideProgress: true,
  },
  {
    name: 'customV2_plan',
    hideProgress: true,
  },
  {
    name: 'customV2_email',
    hideProgress: true,
  },
  {
    name: 'receive_email',
    hideProgress: true,
  },
  {
    name: 'customV2_specialOffer_v2',
    hideProgress: true,
  },
];
